import React, { useEffect, useState } from "react";
import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import getStripe from "./getStripe";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import AddPaymentMethod from "./AddPaymentMethod";
import Typography from "@mui/material/Typography";
import { Button, CircularProgress } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import { call } from "services/axiosService/core";
import * as Sentry from "@sentry/browser";
import Loader from "pages/loader/Loader";
import { useMaterialUIController } from "context";

export default function PaymentSetupWrapper({
  openAddPaymentMethodModal,
  handleCloseAddPaymentMethodModal,
  setOpenSnackbar,
  setAlertMessage,
  setSeverity,
  addNewPaymentMethod,
  childDetails,
  t,
}) {
  const [clientSecret, setClientSecret] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);
  const [controller] = useMaterialUIController();
  const { profile } = controller;

  useEffect(() => {
    async function initStripe() {
      try {
        const configRes = await call(`payments/config/${profile.id}`, "GET", {});
        if (configRes.status === 200 && configRes.data.publish_key) {
          setStripePromise(getStripe(configRes.data.publish_key));
        }

        const setupRes = await call(`payments/setup-payment-intent/${profile.id}`, "POST", {
          body: { addNewPaymentMethod: addNewPaymentMethod },
        });

        if (setupRes.status === 200 && setupRes.data.clientSecret) {
          setClientSecret(setupRes.data.clientSecret);
        } else if (setupRes.status === 200 && !setupRes.data.clientSecret) {
          handleCloseAddPaymentMethodModal();
        } else if (setupRes.status === 440) {
          handleCloseAddPaymentMethodModal();
        }
      } catch (err) {
        console.error(err);
        Sentry.captureException(err);
      }
    }

    if (openAddPaymentMethodModal) {
      initStripe();
    }
  }, [openAddPaymentMethodModal, profile.id]);

  const options = {
    clientSecret,
    appearance: {
      theme: "flat", // Or "none" to avoid any Stripe theme interference
    },
  };

  return (
    <Dialog open={openAddPaymentMethodModal}>
      <CloseIcon
        fontSize="medium"
        aria-label="close"
        onClick={handleCloseAddPaymentMethodModal}
        style={{ color: "red", display: "block", marginLeft: "auto", cursor: "pointer" }}
      />
      <>
        {!stripePromise || !clientSecret ? (
          <DialogContent
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
              overflow: "hidden",
              padding: 4,
            }}
          >
            <Loader loaderText={t("loaderText.processingRequest")} />
          </DialogContent>
        ) : (
          <>
            <DialogTitle>
              <MDBox textAlign="center" mb={3}>
                <MDBox
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    bgcolor: "#4caf5018",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  <Icon sx={{ fontSize: "40px !important", color: "#4caf50" }}>credit_card</Icon>
                </MDBox>
                <MDTypography variant="h5" fontWeight="bold" mb={0.5}>
                  {t(`headings.addPayment`)}
                </MDTypography>
                <MDTypography variant="body2" color="text.secondary">
                  {t(`messages.subscription.addPayment`)}
                </MDTypography>
              </MDBox>

              {/* <Typography variant="h4" textAlign="center" mb={1}>
                {t(`headings.addPayment`)}
              </Typography>
              <Typography variant="h6" textAlign="center" mb={2}>
                {t(`messages.subscription.addPayment`)}
              </Typography> */}
            </DialogTitle>
            <DialogContent>
              <Elements stripe={stripePromise} options={options}>
                <AddPaymentMethod
                  clientSecret={clientSecret}
                  handleClose={handleCloseAddPaymentMethodModal}
                  setOpenSnackbar={setOpenSnackbar}
                  setAlertMessage={setAlertMessage}
                  setSeverity={setSeverity}
                  childDetails={childDetails}
                />
              </Elements>
            </DialogContent>
          </>
        )}
      </>
    </Dialog>
  );
}
